import React from 'react'
import {Modal} from 'react-bootstrap'
import {KTIcon} from '../../../_metronic/helpers'
import {DemandeDemontageAnnulationForm} from './components/DemandeDemontageAnnulationForm'

const DemandeDemontageAnnulationModal = ({show, demandeDemontageId, showModal, data, setData}) => {
  return (
    <>
      <Modal
        size='lg'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        show={show}
        onHide={() => showModal(false)}
        backdrop={true}
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>
              Annulation de la demande de démontage pour la demande n° : {demandeDemontageId}
            </h5>
            <div
              className='btn btn-icon btn-sm btn-light-primary ms-2'
              onClick={() => showModal(false)}
            >
              <KTIcon className='fs-2' iconName='cross' />
            </div>
          </div>
          <DemandeDemontageAnnulationForm
            demandeDemontageId={demandeDemontageId}
            showModalProp={showModal}
            setData={setData}
            data={data}
          />
        </div>
      </Modal>
    </>
  )
}

export {DemandeDemontageAnnulationModal}
